exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.boton {\r\n\ttext-align:center;\r\n\tcursor:pointer;\n}\r\n", ""]);

// exports
